import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import enTranslation from './locales/en/translation.json';

// Supported languages — each can be progressively translated.
// Languages without resources fall back to English.
export const SUPPORTED_LANGUAGES = [
  { code: 'en', name: 'English', rtl: false },
  { code: 'es', name: 'Español', rtl: false },
  { code: 'fr', name: 'Français', rtl: false },
  { code: 'pt', name: 'Português', rtl: false },
  { code: 'it', name: 'Italiano', rtl: false },
  { code: 'de', name: 'Deutsch', rtl: false },
  { code: 'ar', name: 'العربية', rtl: true },
  { code: 'zh', name: '中文', rtl: false },
  { code: 'ja', name: '日本語', rtl: false },
  { code: 'ko', name: '한국어', rtl: false },
];

const RTL_LANGUAGES = SUPPORTED_LANGUAGES.filter(l => l.rtl).map(l => l.code);

export const applyLanguageDirection = (lng) => {
  const isRtl = RTL_LANGUAGES.includes(lng);
  document.documentElement.dir = isRtl ? 'rtl' : 'ltr';
  document.documentElement.lang = lng;
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: { translation: enTranslation },
      // Other languages will fall back to English until translations are added.
      // To add a translation: import and add here.
    },
    fallbackLng: 'en',
    supportedLngs: SUPPORTED_LANGUAGES.map(l => l.code),
    nonExplicitSupportedLngs: true,
    interpolation: { escapeValue: false },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'stylegenome_lang',
    },
  });

// Apply RTL/direction on initial load and on every language change
applyLanguageDirection(i18n.language || 'en');
i18n.on('languageChanged', applyLanguageDirection);

export default i18n;
